import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import localeMixin from '@/locales/mixin.js'
import { mapState, mapActions } from 'vuex';
import utils from '@/utils';
export default {
  // mixins: [
  //   localeMixin
  // ],
  data: function data() {
    return {// activeName:utils.cookies.get('TimeZoneNN'),
    };
  },
  computed: _objectSpread({}, mapState('d2admin/time', ['list', 'activeName'])),
  mounted: function mounted() {
    console.log(utils.cookies.get('TimeZoneNN'), "^^^^^^^^^^^^^^^^^^^^^"); // this.data.activeName=utils.cookies.get('TimeZoneNN')
    // this.set(utils.cookies.get('TimeZoneNN'))

    this.load();
  },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/time', ['set', "load"])), {}, {
    onChangeLocale: function onChangeLocale(command) {
      console.log(command);
      this.set(command);
      this.$notify({
        title: this.$t("变更成功"),
        dangerouslyUseHTMLString: true,
        message: this.$t("请刷新页面")
      });
    }
  })
};